import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.scss'],
})
export class StudentComponent implements OnInit {

  currentLang = 'en';

  constructor(private translate : TranslateService) {}

  ngOnInit(): void {
    console.log('s');
    this.currentLang = this.translate.currentLang;
  }
}
